import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import {
  EntityContentBlueprint,
  EntityContentLayoutBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import RepositoryIcon from '@material-ui/icons/Storage';
import CloudIcon from '@material-ui/icons/Cloud';
import BugReportIcon from '@material-ui/icons/BugReport';
import DnsIcon from '@material-ui/icons/Dns';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { createElement } from 'react';
import { CatalogExplorerPage } from './CatalogExplorerPage';
import { PagerDutyTeamsExplorerPage } from './PagerDutyTeamsExplorerPage';
import { KaaPTenantExplorerPage } from '@internal/backstage-plugin-kaap-frontend';
import { CatalogFeature } from './catalogFeatures';
import {
  groupColumns,
  userColumns,
  subscriptionColumns,
  jiraTeamColumns,
  kubernetesClusterColumns,
} from './catalogColumns';

const aboutRelationsLayout = EntityContentLayoutBlueprint.make({
  name: 'about-relations',
  params: {
    loader: async () => {
      const { AboutRelationsEntityContentLayout } = await import(
        './AboutRelationsEntityContentLayout'
      );
      return AboutRelationsEntityContentLayout;
    },
  },
});

const systemDiagramTab = EntityContentBlueprint.make({
  name: 'system-diagram',
  params: {
    path: '/diagram',
    title: 'Diagram',
    filter: 'kind:system',
    loader: async () => {
      const { SystemDiagramContent } = await import('./SystemDiagramContent');
      return createElement(SystemDiagramContent);
    },
  },
});

const groupFeatures = [
  { [CatalogFeature.KindSelector]: false },
  { [CatalogFeature.TypeSelector]: false },
  CatalogFeature.Owned,
  CatalogFeature.OwnerSelector,
  CatalogFeature.BusinessProductUnitSelector,
];

const userFeatures = [
  { [CatalogFeature.KindSelector]: false },
  { [CatalogFeature.Owned]: false },
  CatalogFeature.BusinessProductUnitSelector,
];

export const catalogPagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'catalog-groups',
      params: {
        path: '/catalog/groups',
        title: 'Catalog Groups',
        icon: createElement(GroupIcon),
        loader: async () =>
          createElement(CatalogExplorerPage, {
            initialKind: 'group',
            features: groupFeatures,
            columns: groupColumns,
          }),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-users',
      params: {
        path: '/catalog/users',
        title: 'Catalog Users',
        icon: createElement(PersonIcon),
        loader: async () =>
          createElement(CatalogExplorerPage, {
            initialKind: 'user',
            features: userFeatures,
            columns: userColumns,
          }),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-repositories',
      params: {
        path: '/catalog/repositories',
        title: 'Catalog Repositories',
        icon: createElement(RepositoryIcon),
        loader: async () =>
          createElement(CatalogExplorerPage, {
            initialKind: 'repository',
          }),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-subscriptions',
      params: {
        path: '/catalog/subscriptions',
        title: 'Catalog Subscriptions',
        icon: createElement(CloudIcon),
        loader: async () =>
          createElement(CatalogExplorerPage, {
            initialKind: 'resource',
            initialType: 'subscription',
            columns: subscriptionColumns,
          }),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-kubernetes-clusters',
      params: {
        path: '/catalog/kubernetes-clusters',
        title: 'Kubernetes Clusters',
        icon: createElement(DeviceHubIcon),
        loader: async () =>
          createElement(CatalogExplorerPage, {
            initialKind: 'resource',
            initialType: 'kubernetes-cluster',
            columns: kubernetesClusterColumns,
          }),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-jira-teams',
      params: {
        path: '/catalog/jira-teams',
        title: 'Catalog Jira Teams',
        icon: createElement(BugReportIcon),
        loader: async () =>
          createElement(CatalogExplorerPage, {
            initialKind: 'component',
            initialType: 'jira-team',
            columns: jiraTeamColumns,
          }),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-pagerduty-teams',
      params: {
        path: '/catalog/pagerduty-teams',
        title: 'Catalog PagerDuty Teams',
        icon: createElement(NotificationsActiveIcon),
        loader: async () => createElement(PagerDutyTeamsExplorerPage),
      },
    }),
    PageBlueprint.make({
      name: 'catalog-kaap-tenants',
      params: {
        path: '/catalog/kaap-tenants',
        title: 'KaaP Tenants',
        icon: createElement(DnsIcon),
        loader: async () => createElement(KaaPTenantExplorerPage),
      },
    }),
    aboutRelationsLayout,
    systemDiagramTab,
  ],
});